import { ActionTypes } from "../../constants/ActionTypes";
import { IBaseConfigReducer } from "../../interfaces/BaseConfig";

const INIT_STATE: IBaseConfigReducer = {
  companyName: "",
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_Company_Name: {
      return {
        companyName: action.companyName,
      };
    }
    case ActionTypes.FETCH_GET_Company_Name_SUCCESS: {
      return {
        companyName: action.payload,
      };
    }
    default:
      return state;
  }
};
